import type { SxProps } from '@mui/material';
import { flatSx, FlexRow } from '@ocodelib/mui';
import { sxAbsolute } from '@repo-foundation/util/sx-util';
import { nanumSquareRound } from '@repo-ui/font';
import clsx from 'clsx';
import { TUT_LEVEL_COLORS } from './tut-constants';
import type { TutLevelKey } from './tut-types';

interface Props {
  level: TutLevelKey;
  levelName: string;
  sx?: SxProps;
  size?: 'small' | 'medium';
}

export default function TutorLevelMark(props: Props) {
  const { level, levelName, sx, size = 'medium' } = props;
  const { primary: themePrimaryColor } = TUT_LEVEL_COLORS[level];
  return (
    <FlexRow
      center
      className={clsx('TutorLevelMark-root', {
        x_small: size === 'small',
      })}
      sx={flatSx(
        {
          ...sxAbsolute({ top: '15px', left: '15px' }),
          border: `2px solid ${themePrimaryColor}`,
          color: themePrimaryColor,
          background: 'rgba(255,255,255,0.85)',
          borderRadius: '50%',
          fontWeight: 700,
          fontFamily: nanumSquareRound.style.fontFamily,
          width: 60,
          height: 60,

          fontSize: '1.05rem',

          '&.x_small': {
            width: 45,
            height: 45,
            top: '10px',
            left: '10px',
            fontSize: '0.8rem',
          },
        },
        sx,
      )}
    >
      {levelName}
    </FlexRow>
  );
}
